<app-filters id="filters" (filtersChanged)="onFiltersChanged($event)"></app-filters>

@if(favoriteMode && pagedCompanies.length == 0){
  <div class="flex flex-col items-center justify-center h-full p-5 text-center">
    <img src="/images/logo/Referio.png" alt="No Favorites" class="mb-4" width="150">
    <h2 class="text-2xl font-semibold mb-2">Aucun Favoris</h2>
    <p class="text-gray-600">Vous n'avez ajouté aucune entreprise à vos favoris. Commencez à explorer et ajoutez-en !</p>
  </div>
} @else {
  <div class="row mt-5" style="min-height: 25vh;">
    @for (company of pagedCompanies; track company._id) {
      <app-company-card
        [company]="company"
        class="col-md-3 col-sm-6 mb-3"
      />
    } @empty {

      <div class="flex flex-col items-center justify-center w-full p-10 text-center">
        <mat-icon class="text-gray-300 mb-4" style="font-size: 64px; width: 64px; height: 64px;">search_off</mat-icon>
        <h2 class="text-2xl font-semibold mb-2">Aucune entreprise trouvée</h2>
      </div>
    }
  </div>
}

<mat-paginator
  [length]="totalCompanies"
  [pageSize]="pageSize"
  [pageSizeOptions]="[8, 16, 32]"
  (page)="onPageChange($event)">
</mat-paginator>